import { useState, useEffect } from 'react';
import { 
  onSnapshot, 
  query, 
  collection, 
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const useArticles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const q = query(collection(db, 'articles'), orderBy('createdAt', 'desc'));
    
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(doc => {
          const docData = doc.data();
          return { 
            id: doc.id, 
            ...docData,
            createdAt: docData.createdAt.toDate ? docData.createdAt.toDate() : new Date()
          };
        });
        console.log('Articles chargés:', data.length);
        setArticles(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Erreur Firestore:', err);
        if (err.code === 'permission-denied') {
          setError('Permission refusée. Vérifiez les règles Firestore dans la console Firebase.');
        } else {
          setError(err.message);
        }
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const createArticle = async (data) => {
    try {
      const docRef = await addDoc(collection(db, 'articles'), {
        ...data,
        createdAt: new Date(),
        views: 0
      });
      console.log('Article créé avec ID:', docRef.id);
      return { success: true };
    } catch (err) {
      console.error('Erreur création article:', err);
      return { success: false, error: err.message };
    }
  };

  const editArticle = async (id, data) => {
    try {
      const articleDoc = doc(db, 'articles', id);
      await updateDoc(articleDoc, data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const removeArticle = async (id) => {
    try {
      const articleDoc = doc(db, 'articles', id);
      await deleteDoc(articleDoc);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  return {
    articles,
    loading,
    error,
    createArticle,
    editArticle,
    removeArticle
  };
};
